import {
  sendAnalyticsInfo,
  sendAnalyticsError,
} from 'features/analytics/helpers';
import type { AppDispatch } from 'features/app/store/store';

export interface ConnectionStartAnalyticsPayload {
  instanceNumber: number;
  totalConnections: number;
  activeConnections: number;
}

export interface ConnectionCloseAnalyticsPayload {
  instanceNumber: number;
  totalConnections: number;
  activeConnections: number;
}

export interface WebSocketOpenAnalyticsPayload {
  relayId: string;
  wsUrl: string;
  eventType: string;
  eventTimestamp: number;
}

export interface WebSocketErrorAnalyticsPayload {
  relayId: string;
  wsUrl: string;
  readyState: number;
  eventType: string;
  eventTimestamp: number;
}

export interface WebSocketCloseAnalyticsPayload {
  relayId: string;
  wsUrl: string | undefined;
  code: number;
  reason: string;
  wasClean: boolean;
  eventType: string;
  eventTimestamp: number;
  readyState: number | undefined;
}

export function dispatchConnectionStartAnalytics(
  dispatch: AppDispatch,
  payload: ConnectionStartAnalyticsPayload
) {
  dispatch(
    sendAnalyticsInfo({
      method: 'TrainingConnectionSavvy.startConnection',
      eventName: 'training_forker_connection_start',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export function dispatchConnectionCloseAnalytics(
  dispatch: AppDispatch,
  payload: ConnectionCloseAnalyticsPayload
) {
  dispatch(
    sendAnalyticsInfo({
      method: 'TrainingConnectionSavvy.closeConnection',
      eventName: 'training_forker_connection_close',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export function dispatchWebSocketOpenAnalytics(
  dispatch: AppDispatch,
  payload: WebSocketOpenAnalyticsPayload
) {
  dispatch(
    sendAnalyticsInfo({
      method: 'TrainingConnectionSavvy.WebSocketOpen',
      eventName: 'training_forker_ws_open',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export function dispatchWebSocketErrorAnalytics(
  dispatch: AppDispatch,
  payload: WebSocketErrorAnalyticsPayload
) {
  dispatch(
    sendAnalyticsError({
      method: 'TrainingConnectionSavvy.WebSocketError',
      eventName: 'training_forker_ws_error',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}

export function dispatchWebSocketCloseAnalytics(
  dispatch: AppDispatch,
  payload: WebSocketCloseAnalyticsPayload
) {
  dispatch(
    sendAnalyticsInfo({
      method: 'TrainingConnectionSavvy.WebSocketClose',
      eventName: 'training_forker_ws_close',
      details: payload,
      logGroup: 'training_forker',
    })
  );
}
